module.exports = __webpack_public_path__ + "media/images/index/feature/top-coj-e-8619b22dee650fe23c56bf37adba8491.png";